export enum AlertTypes {
  Custom = 'custom alert',
  TaskTriggered = 'task triggered',
  ProjectExpiringSoon = 'project expiring soon',
  TaskCompleted = 'task completed',
  TaskCancelled = 'task cancelled',
  TaskPutOnHold = 'task put on hold',
  TaskStarted = 'task started',
  TokenEarned = 'token earned',
  CoinsEarned = 'coins earned',
  MetricUpdated = 'metric updated',
}
